<template>
	<div>
		<dynamic-chart 
			chart="lobster_analytics"
		/>
	</div>
</template>

<style lang="scss">
	body {
		&[data-screen="analytics"] {
			background: #333333;
			color: #f0f0f0;

			main.content {
				padding: 0;
			}
		}
	}
</style>

<script>
	import DynamicChart from '@/ui/components/DynamicChart';

	export default {
		components: {
			DynamicChart
		}	
	};
</script>